// BIGLI-59：LINE 官方帳號設定與「LINE 新需求」API。
import api from './api';

export const getLineChannels = async () => (await api.get('/line/channels')).data;

export const saveLineChannel = async (store, payload) =>
  (await api.put(`/line/channels/${encodeURIComponent(store)}`, payload)).data;

export const getLineInquiries = async (params = {}) => {
  // BIGLI-145：用嚴格判空，`if (v)` 會把 offset=0 這類合法數值一起吃掉
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  return (await api.get(`/line/inquiries?${q.toString()}`)).data;
};

export const getLineInquiry = async (id) => (await api.get(`/line/inquiries/${id}`)).data;

export const updateLineInquiry = async (id, payload) => (await api.put(`/line/inquiries/${id}`, payload)).data;

export const recheckLineInquiry = async (id) => (await api.post(`/line/inquiries/${id}/recheck`)).data;

export const linkInquiryQuotation = async (id, quotationId) =>
  (await api.put(`/line/inquiries/${id}/quotation`, { quotationId })).data;

// BIGLI-107：LINE 帳號 ↔ 客戶綁定
export const searchInquiryCustomerCandidates = async (id, q = '') =>
  (await api.get(`/line/inquiries/${id}/customer-candidates?q=${encodeURIComponent(q)}`)).data;

export const bindInquiryCustomer = async (id, customerId) =>
  (await api.put(`/line/inquiries/${id}/customer`, { customerId })).data;

export const unbindInquiryCustomer = async (id) => (await api.delete(`/line/inquiries/${id}/customer`)).data;

// BIGLI-111：轉給其他門市／接手／轉入待接手數量
export const transferLineInquiry = async (id, toStore, reason) =>
  (await api.post(`/line/inquiries/${id}/transfer`, { toStore, reason })).data;

export const acceptLineInquiryTransfer = async (id) => (await api.post(`/line/inquiries/${id}/accept-transfer`)).data;

export const getTransferPendingCounts = async () => (await api.get('/line/inquiries/transfer-pending-counts')).data;

// BIGLI-110：未讀通知（側欄紅點／門市 tab）與打開明細時標記已讀
export const getLineUnreadCount = async () => (await api.get('/line/inquiries/unread-count')).data;

export const markLineInquiryRead = async (id) => (await api.put(`/line/inquiries/${id}/read`)).data;
